export default __webpack_public_path__ + "static/media/logo_ukl_cmyk.f1959049.svg";